import { NavLink } from 'react-router-dom';
import styles from './CreatePost.module.css';
import { IconButton } from './IconButton';
import { IconLogin } from './QuirkIcons';

export const FeedLogin = ({ label }: { label?: string }) => {
	return (
		<>
			<div className={styles.container}>
				<NavLink to={`/main/settings/login`} className="nounderline">
					<IconButton
						label={label}
						icon={
							<span className="iconCircleGray">
								<IconLogin />
							</span>
						}
					/>
				</NavLink>
			</div>
			<hr />
		</>
	);
};
